import React from 'react';
import { IStyleProps, LottieAnimation } from '../LottieAnimation';
import addFavorite from './addFavorite.json';
import removeFavorite from './removeFavorite.json';

interface ILottieFavoriteProps extends IStyleProps {
  onCheckAnimationEnd?: () => void;
}

export const LottieFavoriteAdd: React.FC<ILottieFavoriteProps> = (props) => (
  <LottieAnimation animationData={addFavorite} loop={false} onComplete={props.onCheckAnimationEnd} {...props} />
);

export const LottieFavoriteRemove: React.FC<ILottieFavoriteProps> = (props) => (
  <LottieAnimation animationData={removeFavorite} loop={false} onComplete={props.onCheckAnimationEnd} {...props} />
);
